import clsx from 'clsx';
import { VideoReviews as VideoReviewsProps } from 'types/studio/studio';
import { getTypographyDefaultColor, RatingStars, Typography } from '@ag1/ui';
import CustomPortableText from 'shared/studio/PortableText/PortableText';

import styles from './VideoReviewsRating.module.scss';

type VideoReviewsRatingProps = {
  className?: string;
} & Pick<VideoReviewsProps, 'ratingValue' | 'ratingTitle'>;

export const VideoReviewsRating = (props: VideoReviewsRatingProps) => {
  const { ratingTitle, ratingValue, className } = props;
  return (
    <>
      {ratingValue && ratingTitle && (
        <aside className={clsx(styles.ratingBlock, className)}>
          <RatingStars
            rating={ratingValue}
            thin
            theme="new"
            className={styles.ratingStars}
            childClassName={styles.paddingSmall}
            inheritFontSize
          />
          <Typography
            variant="portalCaption"
            size="2"
            noPadding
            color={getTypographyDefaultColor('new')}
            className={clsx(styles.ratingTitle)}
            weight="400">
            <CustomPortableText value={ratingTitle} />
          </Typography>
        </aside>
      )}
    </>
  );
};
